module.exports = __webpack_public_path__ + "static/media/radicle-logo.6de8e481.svg";